import z from "zod";

// phone cannot be object, see: https://github.com/react-hook-form/resolvers/issues/458

// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export const deserializePhone = (phone: any) =>
  phone === undefined ? ["", ""] : (String(phone).split("|", 2) as [string, string]);

export const serializePhone = (countryCallCode: string, nationalNumber: string) =>
  `${countryCallCode}|${nationalNumber}`;

export const validatePhone = (phone: string): boolean => {
  if (phone.trim().length > 0) {
    return validateRequiredPhone(phone);
  }

  return false;
};

// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export const validateRequiredPhone = (phone: any): boolean => {
  const [countryCallCode, nationalNumber] = deserializePhone(phone);

  return countryCallCode.trim().length > 0 && nationalNumber.trim().length > 0;
};

export const zRequiredPhone = z.custom<string>(validateRequiredPhone, { message: "required" });
